import axios from '@/bootstrap'
const endpoint = 'annualized-turn-details'

export default class AnnualizedTurnDetailsService {
  list(params) {
    return axios.get(`/api/${endpoint}`, params).then(res => res.data)
  }
}
